import React, { useMemo } from "react";
import useSelect from "../hooks/useSelect";
import {
  Select as SSelect,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from "components/ui/select";

// Props: { options, initialValue, onOptionChange }
// options shape: [{ value, label, color }]
function Select({ options, initialValue, onOptionChange }) {
  const { selectedOption, handleOptionChange } = useSelect(initialValue, onOptionChange);

  // Radix can't use "" as a value; use "all" and map back to "" for your state/backend
  const mapOut = (v) => (v === "" || v == null ? "all" : String(v));
  const mapIn = (v) => (v === "all" ? "" : v);

  const normalizedOptions = useMemo(() => {
    return (options || []).map((opt) => ({
      ...opt,
      value: mapOut(opt.value),
      color: opt.color ?? "transparent",
    }));
  }, [options]);

  // keep your hook working (event-like object)
  const handleRadixChange = (val) => handleOptionChange({ target: { value: mapIn(val) } });

  const currentUIValue = mapOut(selectedOption);

  const selectedColor =
    normalizedOptions.find((o) => o.value === currentUIValue)?.color || "transparent";

  return (
    <div className="w-full">
      <SSelect value={currentUIValue} onValueChange={handleRadixChange}>
        <SelectTrigger
          className="w-full"
          style={{ backgroundColor: selectedColor }}
          aria-label="בחר סטטוס"
        >
          <SelectValue placeholder="בחר" />
        </SelectTrigger>

        <SelectContent position="popper" className="max-h-64">
          {normalizedOptions.map((opt) => (
            <SelectItem
              key={opt.value}
              value={opt.value}
              style={{ backgroundColor: opt.color }}
              className="focus:bg-accent focus:text-accent-foreground"
            >
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </SSelect>
    </div>
  );
}

export default Select;
